import Layout2 from '@/layout/Layout2'
let ja = require('../../common/lang/ja')
let zh = require('../../common/lang/zh-CN')

export default [
  {
    path: "/merchantCoupon",
    component: Layout2,
    meta: {
      zhtitle: zh.m.router.COUPON_USE_RECORD,
      jatitle: ja.m.router.COUPON_USE_RECORD,
    },

    children: [
      {
        path: "",
        name: "merchantCoupon",
        component: () =>
          import(
            /* webpackChunkName: "jp.gift" */ "@/merchanAdmin/merchantCoupon/list.vue"
          ),
        meta: {
          zhtitle: zh.m.router.COUPON_USE_RECORD,
          jatitle: ja.m.router.COUPON_USE_RECORD,
          pername: "coupon_used",
        },
      },
    ],
  },
];
